const about_slider = new Swiper('.about_slider', {
    slidesPerView: 1,
    loop: true,
    centeredslides: true,
    spaceBetween: 50,
    speed: 500,
    loopAdditionalSlides: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 1,
            spaceBetween: 60,
        }
    }

});

const corporate_slider = new Swiper('.corporate_slider', {
    slidesPerView: 1,
    loop: false,
    centeredslides: true,
    spaceBetween: 20,
    speed: 500,
    loopAdditionalSlides: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }

});

const corporate_img_slider = new Swiper('.corporate_img_slider', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    speed: 500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 20,
        }
    }
});

const ranking_slider = new Swiper('.ranking_slider', {
    slidesPerView: 2.2,
    loop: false,
    spaceBetween: 10,
    speed: 500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 35,
        }
    }
});

const florist_list = new Swiper('.florist_list', {
    centeredSlides: true,
    slidesPerView: 1.5,
    loop: false,
    spaceBetween: 20,
    speed: 500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 2.2,
            spaceBetween: 40,
        }
    }
});

const shop_img = new Swiper('.shop_img', {
    slidesPerView: 1,
    loop: true,
    centeredslides: true,
    spaceBetween: 20,
    speed: 2000,
    loopAdditionalSlides: 1,
  effect: 'fade',
  autoplay: {
    delay: 5000, 
  },
    breakpoints: {
        768: {
            slidesPerView: 1,
            spaceBetween: 20,
        }
    }

});
